module.exports = __webpack_public_path__ + "img/7.e8cc2090.jpg";